window.bugsanddrugs = window.bugsanddrugs || {};

bugsanddrugs.update_search_nav = function (name) {
  terms_lookup = {
    A: "A",
    B: "B",
    C: "C",
    D: "D-E",
    E: "D-E",
    F: "F-G",
    G: "F-G",
    H: "H-K",
    I: "H-K",
    J: "H-K",
    K: "H-K",
    L: "L-M",
    M: "L-M",
    N: "N-O",
    O: "N-O",
    P: "P",
    Q: "Q-R",
    R: "Q-R",
    S: "S",
    T: "T",
    U: "U-Z",
    V: "U-Z",
    W: "U-Z",
    X: "U-Z",
    Y: "U-Z",
    Z: "U-Z"
  };

  search_click = terms_lookup[name.substring(0, 1)];

  $.get("/search_entries/search_entries/" + search_click, function (r) {
    eval(r);
  });
}

// delete page
$(document).on("click", "#delete_search_entry_form_toggle", function (e) {
  e.preventDefault();
  $("#delete_search_entry_modal").toggle();
  return false;
});

$(document).on("click", "#delete_search_entry_form_submit", function (e) {
  e.preventDefault();

  let u = $("#delete_search_entry_path").val() + "/delete";
  let name = $("#search_entry_name").val();

  $("#busy_modal").modal("toggle");

  $.ajax({
    type: "POST",
    data: {},
    url: u,
    method: "POST",
    success: function (r) {
      html_page = document.getElementById("html_details");
      html_page.innerHTML = r;

      $("#busy_modal").modal("hide");
      $("#delete_page_modal").modal("hide");
      $(".modal-backdrop").remove();

      bugsanddrugs.update_search_nav(name);
    },
    error: function (request, msg, error) {
      alert("Unable to delete page");
      $("#busy_modal").modal("hide");
      $("#delete_search_entry_modal").modal("hide");
      $(".modal-backdrop").remove();
    }
  });

  return false;
});
